import { render, staticRenderFns } from "./GenerateOrders.vue?vue&type=template&id=6167d06e"
import script from "./GenerateOrders.vue?vue&type=script&lang=js"
export * from "./GenerateOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports